module.exports = __webpack_public_path__ + "static/media/ABE L3 Cert in Biz Startup Booklet.aaea6d39.pdf";